"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFieldGroupFieldName = exports.SIProfileId = exports.IPProfileId = void 0;
__exportStar(require("./functions"), exports);
var types_1 = require("./types");
Object.defineProperty(exports, "IPProfileId", { enumerable: true, get: function () { return types_1.IPProfileId; } });
Object.defineProperty(exports, "SIProfileId", { enumerable: true, get: function () { return types_1.SIProfileId; } });
var field_group_field_name_1 = require("./field-group-field-name");
Object.defineProperty(exports, "getFieldGroupFieldName", { enumerable: true, get: function () { return field_group_field_name_1.getFieldGroupFieldName; } });
//# sourceMappingURL=index.js.map